// ## Components
export const ACCORDION = 'SLDSAccordion';
export const ACCORDION_PANEL = 'SLDSAccordionPanel';
export const ALERT = 'SLDSAlert';
export const ALERT_CONTAINER = 'SLDSAlertContainer';
export const APP_LAUNCHER = 'SLDSAppLauncher';
export const APP_LAUNCHER_EXPANDABLE_SECTION =
	'SLDSAppLauncherExpandableSection';
/* Remove at next breaking change */
export const APP_LAUNCHER_SECTION = 'SLDSAppLauncherSection';
export const APP_LAUNCHER_LINK = 'SLDSAppLauncherLink';
export const APP_LAUNCHER_TILE = 'SLDSAppLauncherTile';
export const APP_LAUNCHER_HEADER = 'SLDSAppLauncherHeader';
export const AVATAR = 'SLDSAvatar';
export const BRAND_BAND = 'SLDSBrandBand';

/* Remove at next breaking change */
export const BREAD_CRUMB = 'SLDSBreadcrumb';

export const BREADCRUMB = 'SLDSBreadcrumb';
export const BUILDER_HEADER = 'SLDSBuilderHeader';
export const BUILDER_HEADER_NAV = 'SLDSBuilderHeaderNav';
export const BUILDER_HEADER_NAV_DROPDOWN = 'SLDSBuilderHeaderNavDropdown';
export const BUILDER_HEADER_NAV_LINK = 'SLDSBuilderHeaderNavLink';
export const BUILDER_HEADER_TOOLBAR = 'SLDSBuilderHeaderToolbar';
export const BUTTON = 'SLDSButton';
export const BUTTON_GROUP = 'SLDSButtonGroup';
export const BUTTON_STATEFUL = 'SLDSButtonStateful';
export const BUTTON_ICON = 'SLDSButtonIcon'; // a non-interctive icon wrapper for SLDSUtilityIcon
export const CARD = 'SLDSCard';
export const CARD_BODY = 'SLDSCardBody';
export const CARD_EMPTY = 'SLDSCardEmpty';
export const CARD_FILTER = 'SLDSCardFilter';
export const CARD_FOOTER = 'SLDSCardFooter';
export const CARD_HEADER = 'SLDSCardHeader';
export const CAROUSEL = 'SLDSCarousel';
export const CAROUSEL_INDICATORS = 'SLDSCarouselIndicators';
export const CAROUSEL_ITEM = 'SLDSCarouselItem';
export const CAROUSEL_NAVIGATORS = 'SLDSCarouselNavigators';
export const CAROUSEL_AUTOPLAY_BUTTON = 'SLDSCarouselAutoplayButton';
export const COLOR_PICKER = 'SLDSColorPicker';
export const COMBOBOX = 'SLDSCombobox';
export const DATA_TABLE = 'SLDSDataTable';
export const DATA_TABLE_CELL = 'SLDSDataTableCell';
export const DATA_TABLE_COLUMN = 'SLDSDataTableColumn';
export const DATA_TABLE_HEAD = 'SLDSDataTableHead';
export const DATA_TABLE_HEADER_CELL = 'SLDSDataTableHeaderCell';
export const DATA_TABLE_ROW_ACTIONS = 'SLDSDataTableRowActions';
export const DATA_TABLE_ROW = 'SLDSDataTableRow';
export const DATE_PICKER = 'SLDSDatePicker';
export const DEPRECATED_WARNING = 'SLDSDeprecatedWarning';
export const DYNAMIC_ICON = 'SLDSDynamicIcon';
export const DIALOG = 'SLDSDialog';
export const EXPANDABLE_SECTION = 'SLDSExpandableSection';
export const FILTER = 'SLDSFilter';
export const CHECKBOX = 'SLDSCheckbox';
export const FORMS_INLINE_EDIT = 'SLDSInlineEdit';
export const INPUT = 'SLDSInput';
export const TEXTAREA = 'SLDSTextarea';
export const SEARCH = 'SLDSSearch';
export const GLOBAL_HEADER = 'SLDSGlobalHeader';
export const GLOBAL_HEADER_BUTTON = 'SLDSGlobalHeaderButton';
export const GLOBAL_HEADER_DROPDOWN = 'SLDSGlobalHeaderDropdown';
export const GLOBAL_HEADER_FAVORITES = 'SLDSGlobalHeaderFavorites';
export const GLOBAL_HEADER_HELP = 'SLDSGlobalHeaderHelp';
export const GLOBAL_HEADER_NOTIFICATIONS = 'SLDSGlobalHeaderNotifications';
export const GLOBAL_HEADER_PROFILE = 'SLDSGlobalHeaderProfile';
export const GLOBAL_HEADER_SEARCH = 'SLDSGlobalHeaderSearch';
export const GLOBAL_HEADER_SETUP = 'SLDSGlobalHeaderSetup';
export const GLOBAL_HEADER_TASK = 'SLDSGlobalHeaderTask';
export const GLOBAL_HEADER_TOOL = 'SLDSGlobalHeaderTool';
export const GLOBAL_NAVIGATION_BAR = 'SLDSGlobalNavigationBar';
export const GLOBAL_NAVIGATION_BAR_BUTTON = 'SLDSGlobalNavigationBarButton';
export const GLOBAL_NAVIGATION_BAR_DROPDOWN = 'SLDSGlobalNavigationBarDropdown';
export const GLOBAL_NAVIGATION_BAR_LABEL = 'SLDSGlobalNavigationBarLabel';
export const GLOBAL_NAVIGATION_BAR_LINK = 'SLDSGlobalNavigationBarLink';
export const GLOBAL_NAVIGATION_BAR_REGION = 'SLDSGlobalNavigationBarRegion';
export const GLOBAL_NAVIGATION_BAR_APP_LAUNCHER =
	'SLDSGlobalNavigationBarAppLauncher';
export const GRID = 'SLDSGrid';
export const HIGHLIGHTER = 'SLDSHighlighter';
export const ICON = 'SLDSIcon';
export const ICON_SETTINGS = 'SLDSIconSettings';
export const ICON_INPUT = 'SLDSIconInput';
export const ILLUSTRATION = 'SLDSIllustration';
export const LIST = 'SLDSList';
export const LIST_ITEM = 'SLDSListItem';
export const LIST_ITEM_LABEL = 'SLDSListItemLabel';
export const LISTBOX_OF_PILL_OPTIONS = 'SLDSListboxOfPillOptions';
export const LOOKUP = 'SLDSLookup';
export const MEDIA_OBJECT = 'SLDSMediaObject';
export const MENU_DROPDOWN = 'SLDSMenuDropdown';
export const MENU_DROPDOWN_TRIGGER = 'SLDSMenuDropdownTrigger';
export const MENU_PICKLIST = 'SLDSMenuPicklist';
export const MODAL = 'SLDSModal';
export const NOTIFICATION = 'SLDSNotification';
export const PANEL = 'SLDSPanel';
export const PANEL_FILTER_GROUP = 'SLDSFilterGroup';
export const PANEL_FILTER_LIST = 'SLDSFilterList';
export const PANEL_FILTER_LIST_HEADING = 'SLDSPanelFilterListHeading';
export const PAGE_HEADER = 'SLDSPageHeader';
export const PILL = 'SLDSPill';
export const PILL_CONTAINER = 'SLDSPillContainer';
export const POPOVER = 'SLDSPopover';
export const POPOVER_EDIT_DIALOG = 'SLDSPopoverEditDialog';
export const POPOVER_TOOLTIP = 'SLDSPopoverTooltip';
export const PROGRESS_INDICATOR = 'SLDSProgressIndicator';
export const PROGRESS_INDICATOR_PROGRESS = 'SLDSProgressIndicatorProgress';
export const PROGRESS_INDICATOR_STEP = 'SLDSProgressIndicatorStep';
export const PROGRESS_INDICATOR_STEP_VERTICAL =
	'SLDSProgressIndicatorStepVertical';
export const PROGRESS_RING = 'SLDSProgressRing';
export const PROGRESS_BAR = 'SLDSProgressBar';
export const SETUP_ASSISTANT = 'SLDSSetupAssistant';
export const SETUP_ASSISTANT_STEP = 'SLDSSetupAssistantStep';
export const SCOPED_NOTIFICATION = 'SLDSScopedNotification';
export const SLIDER = 'SLDSSlider';
export const SPINNER = 'SLDSSpinner';
export const SPLIT_VIEW = 'SLDSSplitView';
export const SPLIT_VIEW_HEADER = 'SLDSSplitViewHeader';
export const SPLIT_VIEW_LISTBOX = 'SLDSSplitViewListbox';
export const RADIO = 'SLDSRadio';
export const RADIO_GROUP = 'SLDSRadioGroup';
export const RADIO_BUTTON_GROUP = 'SLDSRadioButtonGroup';
export const TAB = 'SLDSTab';
export const TAB_ITEM = 'SLDSTabItem';
export const TAB_PANEL = 'SLDSTabPanel';
export const TABS = 'SLDSTabs';
export const TABS_LIST = 'SLDSTabsList';
export const TABS_PANEL = 'SLDSTabsPanel';
export const TIME_PICKER = 'SLDSTimepicker';
export const TOAST = 'SLDSToast';
export const TOAST_CONTAINER = 'SLDSToastContainer';
export const TREE = 'SLDSTree';
export const TREE_BRANCH = 'SLDSTreeBranch';
export const TREE_ITEM = 'SLDSTreeItem';
export const TRIAL_BAR = 'SLDSTrialBar';
export const TRIAL_BAR_DROPDOWN = 'SLDSTrialBarDropdown';
export const TRIAL_BAR_BUTTON = 'SLDSTrialBarButton';
export const VERTICAL_NAVIGATION = 'SLDSVerticalNavigation';
export const VERTICAL_NAVIGATION_ITEM = 'SLDSVerticalNavigationItem';
export const VISUAL_PICKER = 'SLDSVisualPicker';
export const VISUAL_PICKER_LINK = 'SLDSVisualPickerLink';



// WEBPACK FOOTER //
// ./utilities/constants.js